import styled from "styled-components";

export const StyledPageTitle = styled.h3`
  color: ${({ theme }) => theme.colors.darkBlue};
  font-size: 25px;
  display: flex;
  gap: 20px;
  align-items: center;
  margin: 30px 0;
`;
